import { render, staticRenderFns } from "./JLanguageMenu.vue?vue&type=template&id=69e70c80&scoped=true&"
import script from "./JLanguageMenu.vue?vue&type=script&lang=js&"
export * from "./JLanguageMenu.vue?vue&type=script&lang=js&"
import style0 from "./JLanguageMenu.vue?vue&type=style&index=0&id=69e70c80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69e70c80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69e70c80')) {
      api.createRecord('69e70c80', component.options)
    } else {
      api.reload('69e70c80', component.options)
    }
    module.hot.accept("./JLanguageMenu.vue?vue&type=template&id=69e70c80&scoped=true&", function () {
      api.rerender('69e70c80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecg/JLanguageMenu.vue"
export default component.exports